const BAR_COUNT = 48;

let sharedContext = null;

const getAudioContext = () => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) {
    return null;
  }
  if (!sharedContext || sharedContext.state === 'closed') {
    sharedContext = new Ctx();
  }
  return sharedContext;
};

export const normalizePeaks = (values, count = BAR_COUNT) => {
  if (!Array.isArray(values) || values.length === 0) {
    return [];
  }
  const numeric = values
    .map((value) => Number(value))
    .filter((value) => Number.isFinite(value))
    .map((value) => Math.max(0, Math.min(1, value)));
  if (numeric.length === count) {
    return numeric;
  }
  if (numeric.length === 0) {
    return [];
  }
  const out = new Array(count);
  for (let i = 0; i < count; i += 1) {
    const pos = (i / Math.max(1, count - 1)) * (numeric.length - 1);
    const left = Math.floor(pos);
    const right = Math.min(numeric.length - 1, left + 1);
    const mix = pos - left;
    out[i] = (numeric[left] * (1 - mix)) + (numeric[right] * mix);
  }
  return out;
};

export const extractPeaks = async (blob, count = BAR_COUNT) => {
  if (!blob) {
    return [];
  }
  const ctx = getAudioContext();
  if (!ctx) {
    return [];
  }
  if (ctx.state === 'suspended') {
    try {
      await ctx.resume();
    } catch (_) {
      // decode can still work while suspended in some browsers
    }
  }
  const copy = await blob.arrayBuffer();
  const audio = await ctx.decodeAudioData(copy.slice(0));
  const channel = audio.getChannelData(0);
  if (!channel.length) {
    return [];
  }
  const block = Math.max(1, Math.floor(channel.length / count));
  const peaks = new Array(count).fill(0);
  for (let i = 0; i < count; i += 1) {
    const start = i * block;
    const end = Math.min(channel.length, start + block);
    let peak = 0;
    let sumSq = 0;
    const samples = Math.max(1, end - start);
    for (let j = start; j < end; j += 1) {
      const abs = Math.abs(channel[j]);
      if (abs > peak) {
        peak = abs;
      }
      sumSq += channel[j] * channel[j];
    }
    const rms = Math.sqrt(sumSq / samples);
    peaks[i] = (peak * 0.72) + (rms * 0.28);
  }
  const max = Math.max(...peaks, 0.08);
  return peaks.map((value) => Math.max(0.06, Math.min(1, value / max)));
};
